import { createAction } from 'redux-act';

export const goBack = createAction();
export const sendRequest = createAction();
export const requestSent = createAction();
